if(!window.__lxLoaded){window.__lxLoaded=true;
/* LX Jewelry Template — small UI behaviours (drawer, tabs, slider arrows) */
(function(){
  function init(root){
    root = root || document;
    // Menu drawer
    root.querySelectorAll('[data-lx-drawer-open]').forEach(function(btn){
      if (btn.dataset.lxBound) return; btn.dataset.lxBound = 1;
      btn.addEventListener('click', function(){
        var d = document.getElementById(btn.getAttribute('data-lx-drawer-open'));
        if (d){ d.classList.add('is-open'); document.body.style.overflow='hidden'; }
      });
    });
    root.querySelectorAll('[data-lx-drawer-close]').forEach(function(btn){
      if (btn.dataset.lxBound) return; btn.dataset.lxBound = 1;
      btn.addEventListener('click', function(){
        var d = btn.closest('.lx-drawer');
        if (d){ d.classList.remove('is-open'); document.body.style.overflow=''; }
      });
    });
    // Tabs
    root.querySelectorAll('[data-lx-tabs]').forEach(function(wrap){
      if (wrap.dataset.lxBound) return; wrap.dataset.lxBound = 1;
      var tabs = wrap.querySelectorAll('.lx-tab');
      var panels = wrap.querySelectorAll('.lx-panel');
      tabs.forEach(function(tab, i){
        tab.addEventListener('click', function(){
          tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
          panels.forEach(function(p){ p.hidden = true; });
          tab.classList.add('is-active'); tab.setAttribute('aria-selected','true');
          if (panels[i]) panels[i].hidden = false;
        });
      });
    });
    // Slider arrows
    root.querySelectorAll('[data-lx-slider]').forEach(function(wrap){
      if (wrap.dataset.lxBound) return; wrap.dataset.lxBound = 1;
      var track = wrap.querySelector('.lx-track');
      var step = function(){ var c = track.firstElementChild; var g = parseFloat(getComputedStyle(track).columnGap) || 0; return c ? c.getBoundingClientRect().width + g : 300; };
      var prev = wrap.querySelector('.lx-arrow--prev'), next = wrap.querySelector('.lx-arrow--next');
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') document.querySelectorAll('.lx-drawer.is-open').forEach(function(d){ d.classList.remove('is-open'); document.body.style.overflow=''; });
  });
  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
/* v2 behaviours: wishlist toggle, video modal */
(function(){
  document.addEventListener('click', function(e){
    var w = e.target.closest('.lx-card__wish');
    if (w){ e.preventDefault(); w.classList.toggle('is-on'); w.setAttribute('aria-pressed', w.classList.contains('is-on')); return; }
    var v = e.target.closest('[data-lx-video]');
    if (v){
      e.preventDefault();
      var url = v.getAttribute('data-lx-video'); if (!url) return;
      if (/\.(webp|jpe?g|png|gif|avif|svg)(\?|#|$)/i.test(url)) { console.warn('[LX] Video link points to an image, not a video:', url); return; }
      var m = document.getElementById('lx-video-modal');
      if (!m){
        m = document.createElement('div'); m.id='lx-video-modal'; m.className='lx lx-modal';
        m.innerHTML = '<div class="lx-modal__box"><button class="lx-modal__close" aria-label="Close">&times;</button><div class="lx-modal__slot" style="width:100%;height:100%"></div></div>';
        document.body.appendChild(m);
        m.addEventListener('click', function(ev){ if (ev.target===m || ev.target.closest('.lx-modal__close')){ m.classList.remove('is-open'); m.querySelector('.lx-modal__slot').innerHTML=''; } });
      }
      var slot = m.querySelector('.lx-modal__slot');
      var yt = url.match(/(?:youtu\.be\/|v=)([\w-]{11})/), vm = url.match(/vimeo\.com\/(\d+)/);
      slot.innerHTML = yt ? '<iframe src="https://www.youtube.com/embed/'+yt[1]+'?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'
        : vm ? '<iframe src="https://player.vimeo.com/video/'+vm[1]+'?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>'
        : '<video src="'+url+'" controls autoplay playsinline></video>';
      m.classList.add('is-open');
    }
  });
})();

/* Accordion: one item open at a time (fallback for browsers without <details name>) */
document.addEventListener('toggle',function(e){
  var d=e.target;
  if(!d.open||!d.classList||!d.classList.contains('lx-acc__item')) return;
  var acc=d.closest('.lx-acc'); if(!acc) return;
  acc.querySelectorAll('.lx-acc__item[open]').forEach(function(o){ if(o!==d) o.open=false; });
},true);

/* Slider arrows: scroll by one card and hide at either end */
function lxSliderState(wrap){
  var track=wrap.querySelector('.lx-track');if(!track)return;
  var prev=wrap.querySelector('.lx-arrow--prev'),next=wrap.querySelector('.lx-arrow--next');
  var max=track.scrollWidth-track.clientWidth-2;
  if(prev)prev.disabled=track.scrollLeft<=2;
  if(next)next.disabled=track.scrollLeft>=max;
}
function lxInitSliders(root){
  (root||document).querySelectorAll('[data-lx-slider]').forEach(function(wrap){
    var track=wrap.querySelector('.lx-track');if(!track||track.dataset.lxState)return;track.dataset.lxState=1;
    track.addEventListener('scroll',function(){lxSliderState(wrap);},{passive:true});
    window.addEventListener('resize',function(){lxSliderState(wrap);});
    lxSliderState(wrap);
  });
}
document.addEventListener('DOMContentLoaded',function(){lxInitSliders(document);});
document.addEventListener('shopify:section:load',function(e){lxInitSliders(e.target);});

/* Product card metal swatches: swap image, price and metal name */
document.addEventListener('click',function(e){
  var sw=e.target.closest('.lx-pc__sw');
  if(sw){
    e.preventDefault();
    var card=sw.closest('.lx-pc');if(!card)return;
    card.querySelectorAll('.lx-pc__sw').forEach(function(b){b.classList.toggle('is-active',b===sw);b.setAttribute('aria-checked',b===sw);});
    var img=card.querySelector('.lx-pc__img1');
    if(img&&sw.dataset.img){img.removeAttribute('srcset');img.src=sw.dataset.img;}
    var price=card.querySelector('[data-lx-price]');if(price&&sw.dataset.price)price.textContent=sw.dataset.price;
    var name=card.querySelector('[data-lx-metal]');if(name)name.textContent=sw.dataset.name||'';
    var link=card.querySelector('.lx-pc__link');if(link&&sw.dataset.url)link.href=sw.dataset.url;
    return;
  }
  /* Tab switch: refresh arrow state of the newly shown carousel */
  if(e.target.closest('.lx-tab')){
    requestAnimationFrame(function(){document.querySelectorAll('[data-lx-slider]').forEach(function(w){if(typeof lxSliderState==='function')lxSliderState(w);});});
  }
});

/* Parallax backgrounds: layer is 120% tall and drifts up as the section scrolls through */
(function(){
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var ticking=false;
  function update(){
    ticking=false;
    var vh=window.innerHeight;
    document.querySelectorAll('[data-lx-parallax]').forEach(function(sec){
      var layer=sec.querySelector('[data-lx-parallax-layer]');if(!layer)return;
      var r=sec.getBoundingClientRect();
      if(r.bottom<0||r.top>vh)return;
      var progress=(vh-r.top)/(vh+r.height);
      progress=Math.max(0,Math.min(1,progress));
      layer.style.transform='translate3d(0,'+(-progress*r.height*0.2).toFixed(1)+'px,0)';
    });
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  document.addEventListener('DOMContentLoaded',update);
  document.addEventListener('shopify:section:load',update);
})();

/* Shape slider: centered, looping hexagon carousel */
(function(){
  function visibleCount(w){ return w >= 992 ? 5 : 3; }
  function initHexs(root){
    (root||document).querySelectorAll('[data-lx-hexs]').forEach(function(outer){
      if(outer.dataset.lxBound)return; outer.dataset.lxBound=1;
      var stage=outer.querySelector('.lx-hexs__stage');
      var slides=[].slice.call(outer.querySelectorAll('.lx-hexs__slide'));
      var n=slides.length; if(!n)return;
      var section=outer.closest('.lx-hexs');
      var cta=section&&section.querySelector('[data-lx-hexs-cta]');
      var tpl=outer.dataset.template||'Shop [shape]';
      var fallback=outer.dataset.fallbackLink||'#';
      var active=0, prevPos=[];
      function layout(){
        var vis=visibleCount(window.innerWidth);
        var sp=stage.clientWidth/vis, w=sp*0.87, h=w*1.56;
        stage.style.setProperty('--lx-hx-sp',sp+'px');
        stage.style.setProperty('--lx-hx-w',w+'px');
        stage.style.setProperty('--lx-hx-h',h+'px');
        render(vis);
      }
      function render(vis){
        vis=vis||visibleCount(window.innerWidth);
        var half=Math.floor(vis/2);
        slides.forEach(function(el,i){
          var d=i-active;
          if(n>2){ d=((d%n)+n)%n; if(d>n/2) d-=n; }
          var wrapped=prevPos[i]!==undefined && Math.abs(d-prevPos[i])>1;
          el.classList.toggle('no-anim',wrapped);
          el.style.setProperty('--pos',d);
          el.classList.toggle('is-active',d===0);
          el.classList.toggle('is-near',Math.abs(d)===1);
          el.classList.toggle('is-hidden',Math.abs(d)>half);
          el.setAttribute('aria-hidden',Math.abs(d)>half?'true':'false');
          el.tabIndex=Math.abs(d)>half?-1:0;
          prevPos[i]=d;
        });
        if(cta){
          var cur=slides[active];
          cta.textContent=tpl.replace('[shape]',cur.dataset.label||'');
          cta.href=cur.getAttribute('href')||fallback;
        }
        requestAnimationFrame(function(){slides.forEach(function(el){el.classList.remove('no-anim');});});
      }
      function go(i){ active=((i%n)+n)%n; render(); }
      outer.querySelector('.lx-hexs__nav--prev').addEventListener('click',function(){go(active-1);});
      outer.querySelector('.lx-hexs__nav--next').addEventListener('click',function(){go(active+1);});
      slides.forEach(function(el,i){
        el.addEventListener('click',function(e){ if(i!==active){ e.preventDefault(); go(i); } });
      });
      var startX=null, moved=false;
      stage.addEventListener('pointerdown',function(e){startX=e.clientX;moved=false;});
      stage.addEventListener('pointermove',function(e){ if(startX!==null&&Math.abs(e.clientX-startX)>10) moved=true; });
      stage.addEventListener('pointerup',function(e){
        if(startX===null)return; var dx=e.clientX-startX; startX=null;
        if(Math.abs(dx)>40){ go(active+(dx<0?1:-1)); }
      });
      stage.addEventListener('click',function(e){ if(moved){ e.preventDefault(); moved=false; } },true);
      outer.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'){go(active+1);} else if(e.key==='ArrowLeft'){go(active-1);}
      });
      outer.lxHexsGo=function(blockId){
        var i=slides.findIndex(function(el){return el.dataset.shopifyEditorBlock&&el.dataset.shopifyEditorBlock.indexOf(blockId)>-1;});
        if(i>-1) go(i);
      };
      window.addEventListener('resize',layout);
      layout();
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initHexs(document);});
  document.addEventListener('shopify:section:load',function(e){initHexs(e.target);});
  document.addEventListener('shopify:block:select',function(e){
    var outer=e.target.closest&&e.target.closest('[data-lx-hexs]');
    if(outer&&outer.lxHexsGo) outer.lxHexsGo(e.detail.blockId);
  });
})();

/* Footer: link columns always open on desktop, collapsible on mobile */
(function(){
  var mq=window.matchMedia('(min-width: 992px)');
  function sync(root){
    (root||document).querySelectorAll('.lx-foot__col').forEach(function(d){ d.open=mq.matches; });
  }
  document.addEventListener('DOMContentLoaded',function(){sync(document);});
  document.addEventListener('shopify:section:load',function(e){sync(e.target);});
  if(mq.addEventListener) mq.addEventListener('change',function(){sync(document);});
})();

/* Theme editor: open the tab / accordion item being edited */
document.addEventListener('shopify:block:select',function(e){
  var t=e.target;
  if(t.classList&&t.classList.contains('lx-tab')) t.click();
  if(t.tagName==='DETAILS') t.open=true;
});
}
